export default {
  // Page title
  title: 'Task Management',

  // Tabs
  tabs: {
    freightImport: 'Freight Import',
    inquiryImport: 'Inquiry Import',
    import: 'Import Tasks', // Keep compatibility
    export: 'Export Tasks'  // Keep compatibility
  },

  // Search form
  search: {
    fileName: 'File Name',
    fileNamePlaceholder: 'Please enter file name',
    creator: 'Creator',
    creatorPlaceholder: 'Please select creator',
    taskType: 'Source',
    taskTypePlaceholder: 'Please select source',
    status: 'Status',
    statusPlaceholder: 'Please select status',
    operationType: 'Operation Type',
    operationTypePlaceholder: 'Please select operation type',
    timeRange: 'Time Range',
    startTime: 'Start Time',
    endTime: 'End Time',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  // Table titles
  table: {
    freightImportTitle: 'Freight Import Task List',
    inquiryImportTitle: 'Inquiry Import Task List',
    importTitle: 'Import Task List', // Keep compatibility
    exportTitle: 'Export Task List', // Keep compatibility
    columns: {
      fileName: 'File Name',
      source: 'Source',
      operationType: 'Operation Type',
      creator: 'Creator',
      status: 'Status',
      createTime: 'Create Time',
      importTime: 'Import Time',
      exportTime: 'Export Time',
      remark: 'Remark',
      action: 'Action'
    }
  },

  // Status
  status: {
    processing: 'Processing',
    completed: 'Completed',
    failed: 'Failed',
    pending: 'Pending',
    stopped: 'Stopped',
    published: 'Published'
  },

  // Task types
  taskType: {
    fullContainerFreightImport: 'Full Container Freight Import',
    prePortFreightImport: 'Pre-Port Freight Import',
    priceQueryExport: 'Price Query Export',
    railFreightExport: 'Rail Freight Export',
    railSurchargeExport: 'Rail Surcharge Export',
    railSurchargeImport: 'Rail Surcharge Import',
    lastMileFreight: 'Last Mile Freight Import',
    lclFreightImport: 'LCL Freight Import',
    airFreightImport: 'Air Freight Import',
    expressFreightImport: 'Express Freight Import',
    railFreightImport: 'Rail Freight Import',
    surchargeLclImport: 'LCL Surcharge Import',
    surchargeAirImport: 'Air Surcharge Import',
    aICustomerAcquisitionImport: 'AI Customer Acquisition Import',
    portPlatformCopy: 'Platform Port Copy',
    warehousePlatformCopy: 'Platform Warehouse Copy',
    routePlatformCopy: 'Platform Route Copy',
    surchargeFclImport: 'FCL Surcharge Import',
    surchargePrePortImport: 'Pre-Port Surcharge Import',
    surchargeLastMileImport: 'Last Mile Surcharge Import',
    warehouseFclFreightImport: 'Warehouse FCL Freight Import',
    warehouseLclFreightImport: 'Warehouse LCL Freight Import',
    warehouseAirFreightImport: 'Warehouse Air Freight Import',
    warehousePrePortFreightImport: 'Warehouse Pre-Port Freight Import',
    warehouseLastMileFreightImport: 'Warehouse Last Mile Freight Import',
    fclPriceRatio: 'FCL Price Ratio',
    textRateAiImport: 'AI Text Rate Import',
    unknown: 'Unknown Type'
  },

  // Operation types
  operationType: {
    import: 'Import',
    export: 'Export',
    unknown: 'Unknown Operation'
  },

  // Source
  source: {
    superFreight: 'Super Freight',
    orderCenter: 'Order Center',
    customerCenter: 'Customer Center'
  },

  // Action buttons
  actions: {
    view: 'View',
    download: 'Download',
    delete: 'Delete'
  },

  // Delete modal
  deleteModal: {
    title: 'Confirm Delete',
    content: 'This action cannot be undone. Are you sure you want to delete?',
    confirmText: 'Confirm Delete',
    cancelText: 'Cancel'
  },

  // Messages
  messages: {
    loadDataFailed: 'Failed to load data',
    deleteSuccess: 'Delete successful',
    deleteError: 'Delete failed',
    downloadFile: 'Download file',
    downloadSuccess: 'File downloaded successfully',
    downloadFailed: 'File download failed',
    noFileToDownload: 'No file available for download'
  },

  // Task detail
  detail: {
    title: 'Task Detail',
    importTaskDetailTitle: 'Import Task Detail',
    prePortImportTaskDetailTitle: 'Rate Import Detail',
    textRateImportTaskDetailTitle: 'Text Rate AI Import Detail',
    textRateDetail: {
      pageTitle: 'Text Rate AI Import Task Detail',
      statusPublished: 'Published',
      statusPendingPublish: 'Pending Verification (To Publish)',
      statusStopped: 'Stopped',
      statusProcessing: 'Processing',
      taskId: 'Task ID',
      batchNo: 'Batch No',
      creator: 'Creator',
      systemUser: 'System User',
      createdTime: 'Created Time',
      modifiedTime: 'Updated Time',
      carrier: 'Carrier',
      pol: 'POL',
      etd: 'ETD',
      validPeriod: 'Validity Period',
      timelineTitle: 'AI Parsing & Iteration Timeline',
      step1Title: 'v1 Initial Parsing Completed',
      step1Desc: 'AI identified and generated initial FCL rate draft, created task ID: {taskId}',
      step2Title: 'Session Iteration (Latest Batch)',
      step2Desc: 'User corrected fields/rates in chat, draft automatically updated to batch {batchNo}',
      step3PublishedTitle: 'Published & Effective in System',
      step3StoppedTitle: 'Abandoned / Stopped',
      step3PendingTitle: 'Pending User Verification & Confirmation',
      step3PublishedDesc: 'Rate data has been published and can be used for rate query and booking.',
      step3PendingDesc: 'Draft generated. You can view the full table and confirm in the workbench.',
      rawTextTitle: 'Original Input Text (Audit Trace)',
      btnViewDetail: 'View Rate Detail / Export Excel',
      btnGoWorkbench: 'Go to Rate Verification Workbench (Apply/Edit)',
      loadFailed: 'Failed to load task details'
    },
      ratioProgress: {
        title: 'Ratio Task Progress'
      },
    backButton: 'Back to Task List',
    basicInfo: {
      title: 'Task Basic Information',
      taskId: 'Task ID',
      fileName: 'File Name',
      source: 'Source',
      creator: 'Creator',
      status: 'Status',
      processTime: 'Process Time',
      importTime: 'Import Time'
    },
    processLogs: {
      title: 'Process Logs'
    },
    fileInfo: {
      title: 'File Information',
      fileSize: 'File Size',
      duration: 'Process Duration',
      totalRows: 'Total Rows',
      processedRows: 'Processed Rows',
      errorRows: 'Error Rows',
      remark: 'Remark'
    },
    resultPreview: {
      title: 'Result Preview',
      remark: 'Remark',
      totalRows: 'Total Rows',
      successRows: 'Success Rows',
      failedRows: 'Failed Rows',
      copyMode: 'Copy Mode',
      copyModeSync: 'Synchronous',
      copyModeTask: 'Background Task',
      matchedCount: 'Matched',
      requestedCount: 'Requested',
      excludedCount: 'Excluded',
      copiedCount: 'Copied',
      skippedCount: 'Skipped',
      failedCount: 'Failed',
      errorMessage: 'Error Message'
    },
    actions: {
      downloadFile: 'Download File',
      deleteTask: 'Delete Task',
      directPublish: 'Direct Publish',
      saveDraft: 'Save Draft',
      delete: 'Delete'
    },
    table: {
      columns: {
        priceNo: 'Price No.',
        freightType: 'Freight Type',
        pol: 'POL',
        pod: 'POD',
        pot: 'POT',
        transitType: 'Transit Type',
        carrier: 'Carrier',
        contractNo: 'Contract No.',
        cargoType: 'Cargo Type',
        price20GP: '20GP',
        price40GP: '40GP',
        price40HC: '40HC',
        nac: 'NAC',
        creator: 'Creator',
        dateCreated: 'Date Created',
        validPeriod: 'Valid Period',
        action: 'Action'
      },
      freightTypes: {
        contract: 'Contract',
        spot: 'Spot'
      },
      transitTypes: {
        direct: 'Direct',
        transit: 'Transit'
      },
      cargoTypes: {
        general: 'General',
        dangerous: 'Dangerous'
      },
      nacStatus: {
        yes: 'YES',
        no: 'NO'
      }
    },
    publishModal: {
      title: 'Confirm Publish',
      content: 'Are you sure you want to publish all imported rates?',
      confirmText: 'Confirm',
      cancelText: 'Cancel'
    },
    deleteModal: {
      title: 'Confirm Delete',
      content: 'Are you sure you want to delete this rate record? This action cannot be undone.',
      confirmText: 'Confirm Delete',
      cancelText: 'Cancel'
    },
    messages: {
      loadDetailFailed: 'Failed to load task detail',
      loadDataFailed: 'Failed to load rate data',
      deleteSuccess: 'Delete successful',
      deleteFailed: 'Delete failed',
      downloadFile: 'Download file',
      publishSuccess: 'Published successfully, task status updated to published',
      publishFailed: 'Publish failed',
      missingTaskParam: 'Missing task parameter',
      taskParamParseFailed: 'Task parameter parsing failed',
      unknownFile: 'Unknown file',
      unknownCreator: 'Unknown creator',
      loadTaskDetailSuccess: 'Task detail loaded successfully',
      cannotFindTaskId: 'Cannot find task ID',
      apiNoValidData: 'API returned no valid data',
      cannotFindRecord: 'Cannot find record to delete',
      decompressFailed: 'Decompression failed',
      decompressJsonFailed: 'JSON decompression failed',
      noDraftData: 'No data available for draft',
      saveDraftSuccess: '{count} records saved to draft',
      saveDraftFailed: 'Save draft failed'
    },
    processStatus: {
      taskCreated: 'Task Created',
      fileUploaded: 'File Uploaded',
      formatValidation: 'Format Validation',
      dataProcessing: 'Data Processing',
      processCompleted: 'Process Completed'
    },
    dateRange: {
      to: 'to',
      from: 'from'
    },
    batchPublishResult: {
      title: 'Batch Publish Completed',
      titlePartialFailed: 'Batch Publish Completed (Partial Failed)',
      total: 'Total',
      success: 'Success',
      failed: 'Failed',
      errorDetail: 'Error Detail',
      moreErrors: '... and {count} more errors',
      confirm: 'OK',
      unit: 'items'
    },
    parsingRecord: {
      title: 'Parsing Record Detail',
      back: 'Back',
      steps: {
        fileReadSuccess: 'File data read successfully',
        batchNo: 'Batch No.: {no}',
        dataCheck: 'Data Validation',
        checkPassed: 'All data validation passed',
        waiting: 'Waiting for processing...',
        canceled: 'Cancelled',
        dataMatch: 'Data Matching Rules',
        matchRate: 'Match Rate: {rate}%',
        importDone: 'Data Import Completed',
        importRate: 'Success Rate: {rate}%'
      },
      stats: {
        totalCount: 'Total Rows',
        parseSuccess: 'Parse Success',
        newCount: 'New: {count}',
        updateCount: 'Update: {count}',
        parseFailed: 'Parse Failed',
        warningCount: 'Warnings',
        warningInfo: 'Warnings',
        systemError: 'System Error'
      },
      actions: {
        confirmImport: 'Confirm Import',
        cancelImport: 'Cancel Import',
        downloadErrorReport: 'Download Error Details'
      },
      status: {
        processingTip: 'Processing, please wait...'
      },
      taskRemarks: {
        processing: 'Processing the rate warehouse import task',
        failed: 'The rate warehouse import task failed',
        completed: 'The rate warehouse import task completed'
      },
      errors: {
        rowNum: 'Row {row}',
        rowsRange: 'Rows {start}-{end}',
        rowsList: 'Rows {rows}',
        systemField: 'System',
        resultTruncated: 'The validation result was too large and has been summarized. Only some errors are shown; omitted invalid rows were still filtered out.',
        duplicateData: 'Duplicate Data',
        duplicateRate: 'Rate with the same dimensions already exists',
        duplicateAirRate: 'Air freight rate with the same dimensions already exists',
        duplicateLclRate: 'LCL freight rate with the same dimensions already exists'
      },
      messages: {
        confirmSuccess: 'Import confirmed',
        confirmFailed: 'Failed to confirm import',
        cancelSuccess: 'Import cancelled',
        cancelFailed: 'Failed to cancel import',
        noValidData: 'No valid data in the file',
        warehouseDirectSave: 'Valid rate warehouse rows were saved directly and require no confirmation. Invalid rows were skipped and can be corrected from the error report.',
        errorReportFileName: 'Rate_Warehouse_Import_Errors_{batchNo}.xlsx',
        errorReportDownloadSuccess: 'Error details downloaded successfully',
        errorReportDownloadFailed: 'Failed to download error details'
      },
      excel: {
        fields: {
          airline: 'Airline',
          carrier: 'Carrier',
          polAir: 'POL (Air)',
          podAir: 'POD (Air)',
          polSea: 'POL (Sea)',
          podSea: 'POD (Sea)',
          price: 'Unit Price',
          unitSea: 'Billing Unit',
          transportTerm: 'Transport Term',
          tradeTerm: 'Trade Term',
          validFrom: 'Valid From',
          validTo: 'Valid To',
          chargeName: 'Charge Name',
          supplier: 'Supplier',
          port: 'Port',
          currency: 'Currency',
          paymentTerms: 'Payment Terms',
          podRouteCategory: 'POD Route Category',
          polRouteCategory: 'POL Route Category',
          polTerminal: 'POL Terminal',
          originCountry: 'Origin Country',
          originCity: 'Origin City',
          destCountry: 'Dest Country',
          destCity: 'Dest City',
          file: 'File',
          billingUnit: 'Billing Unit',
          isTotalIncluded: 'Total Included',
          isCountTotal: 'Count Into Total',
          pod: 'POD',
          podRoute: 'POD Route Category',
          pol: 'POL',
          podTerminal: 'POD Terminal',
          polRoute: 'POL Route Category',
          containerPrice: 'Container Price',
          unitRate: 'Fee (BL)',
          measure: 'Measure',
          cargoType: 'Cargo Type',
          priceMethod: 'Price Method',
          branchLine: 'Branch Line Type',
          seaRail: 'Sea-Rail Type',
          province: 'Province',
          city: 'City',
          district: 'District',
          town: 'Town/Street',
          community: 'Community',
          airPort: 'Departure Airport',
          country: 'Country',
          wholeRow: 'Whole Row',
          expressSupplier: 'Express Carrier',
          accountNo: 'Account',
          supplierEnterpriseId: 'Supplier',
          serviceType: 'Service Type',
          origin: 'Origin',
          destination: 'Destination',
          originWarehouse: 'Origin Warehouse',
          destinationWarehouse: 'Destination Warehouse',
          billingModel: 'Billing Model',
          loadMode: 'Load Mode',
          billingMethod: 'Billing Method',
          volumetricFactor: 'Volumetric Factor',
          minBillingWeight: 'Minimum Billing Weight',
          pickupFee: 'Pickup Fee',
          deliveryFee: 'Delivery Fee',
          loadingFee: 'Loading Fee',
          vehicleCapacity: 'Vehicle Capacity',
          vehicleVolume: 'Vehicle Volume',
          tripPrice: 'FTL Trip Price',
          kmPrice: 'Kilometer Price',
          minKm: 'Minimum KM',
          firstWeightThreshold: 'First Weight',
          firstWeightPrice: 'First Weight Price',
          additionalWeightUnit: 'Additional Weight Unit',
          additionalWeightPrice: 'Additional Weight Price',
          unitPrice: 'Unit Price',
          weightStart: 'Weight Start',
          weightEnd: 'Weight End',
          weightTierUnitPrice: 'Weight Tier Unit Price',
          weightTierAdditionalPrice: 'Weight Tier Additional Price',
          weightTierMinCharge: 'Minimum Charge (Total Price)',
          minCharge: 'Minimum Charge',
          beginDate: 'Effective Date',
          endDate: 'Expiry Date',
          paymentTerm: 'Payment Term',
          transportMode: 'Transport Mode',
          containerOwnership: 'Container Ownership',
          freeDetentionDays: 'Free Detention Days',
          freeDemurrageDays: 'Free Demurrage Days',
          externalSource: 'Data Source',
          surchargeNames: 'Surcharge Name',
          logicalRate: 'Logical Rate',
          excelFormat: 'Excel Format',
          warehouseGeneric: 'Rate Field',
          unsupportedFields: 'Unsupported Fields'
        },
        errors: {
          notEmpty: 'Cannot be empty',
          invalidNumber: 'Must be a valid numeric format',
          invalidDateValue: 'Invalid date format',
          invalidInteger: 'Must be a non-negative integer or a valid integer range',
          invalidContainerOwnership: 'Only COC (carrier-owned) or SOC (shipper-owned) is supported',
          defaultSupplierNotFound: 'Booking Agent is empty and no available default supplier is configured for this tenant',
          noData: 'No valid data rows were read. Check the template data start row.',
          warehouseTemplateHeaderInvalid: 'The headers do not match the current rate warehouse import template',
          masterDataNotFound: 'No matching system master data was found',
          warehouseValidationFailed: 'The value does not meet the rate warehouse import rules',
          warehouseSaveFailed: 'Failed to save this rate. Correct the data and try again.',
          invalidDate: 'Invalid date format: {0}',
          invalidValue: 'Invalid value: {0}',
          fileReadFailed: 'Failed to read file data: {0}',
          notFoundAirline: 'No corresponding airline in system: {0}',
          notFoundCarrier: 'No corresponding carrier in system: {0}',
          notFoundPolAir: 'No corresponding departure airport in system: {0}',
          notFoundPodAir: 'No corresponding destination airport in system: {0}',
          notFoundPolSea: 'No corresponding POL in system: {0}',
          notFoundPodSea: 'No corresponding POD in system: {0}',
          notFoundUnitSea: 'No corresponding billing unit in system: {0}',
          notFoundTransportTerm: 'No corresponding transport term in system: {0}',
          notFoundTradeTerm: 'No corresponding trade term in system: {0}',
          notFoundChargeName: 'No corresponding charge name in system: {0}',
          notFoundSupplier: 'No corresponding supplier in system: {0}',
          notFoundPort: 'No corresponding port in system: {0}',
          notFoundPolTerminal: 'No corresponding POL terminal in system: {0}',
          notFoundOriginCountry: 'No corresponding origin country in system: {0}',
          notFoundOriginCity: 'No corresponding origin city in system: {0}',
          notFoundDestCountry: 'No corresponding destination country in system: {0}',
          notFoundDestCity: 'No corresponding destination city in system: {0}',
          file: 'File',
          billingUnit: 'Billing Unit',
          isTotalIncluded: 'Total Included',
          isCountTotal: 'Count Into Total',
          pod: 'POD',
          podRoute: 'POD Route Category',
          pol: 'POL',
          por: 'POR',
          pdl: 'PDL',
          transferPort: 'Transfer Port',
          podTerminal: 'POD Terminal',
          polRoute: 'POL Route Category',
          containerPrice: 'Container Price',
          unitRate: 'Fee (BL)',
          measure: 'Measure',
          cargoType: 'Cargo Type',
          priceMethod: 'Price Method',
          branchLine: 'Branch Line Type',
          seaRail: 'Sea-Rail Type',
          province: 'Province',
          city: 'City',
          district: 'District',
          town: 'Town/Street',
          community: 'Community',
          airPort: 'Departure Airport',
          country: 'Country',
          wholeRow: 'Whole Row',
          notFoundPod: 'No corresponding POD in system: {0}',
          notFoundPodRoute: 'No corresponding POD route category in system: {0}',
          notFoundPol: 'No corresponding POL in system: {0}',
          notFoundPor: 'No corresponding POR in system: {0}',
          notFoundPdl: 'No corresponding PDL in system: {0}',
          notFoundTransferPort: 'No corresponding transfer port in system: {0}',
          notFoundPodTerminal: 'No corresponding POD terminal in system: {0}',
          notFoundPolRoute: 'No corresponding POL route category in system: {0}',
          containerPriceRequired: 'At least one container type price is required when unit is "Container"',
          unitRateRequired: 'Unit rate cannot be empty',
          notFoundMeasure: 'No corresponding measure in system: {0}',
          notFoundCargoType: 'No corresponding cargo type in system: {0}',
          dataLogicConflict: 'Data logic conflict: when "Count Into Total" is "Yes", "Total Included" cannot be "Yes", please re-enter',
          notFoundPriceMethod: 'No corresponding price method in system: {0}',
          notFoundBranchLine: 'No corresponding branch line type in system: {0}',
          notFoundSeaRail: 'No corresponding sea-rail type in system: {0}',
          notFoundProvince: 'No corresponding province in system: {0}',
          notFoundCity: 'No corresponding city in system: {0}',
          notFoundDistrict: 'No corresponding district in system: {0}',
          notFoundTown: 'No corresponding town/street in system: {0}',
          notFoundCommunity: 'No corresponding community in system: {0}',
          notFoundAirPort: 'No corresponding departure airport in system: {0}',
          multiDistrictNoTown: 'When multiple districts are selected, town/street, community, and detail address cannot be filled',
          multiTownNoCommunity: 'When multiple towns/streets are selected, community and detail address cannot be filled',
          multiCommunityNoDetail: 'When multiple communities are selected, detail address cannot be filled',
          notFoundCountry: 'No corresponding country in system: {0}',
          multiDistrictNoDetailAddress: 'When multiple districts are selected, detail address cannot be filled',
          saveFailed: 'Save failed: {0}',
          expressBillingModelInvalid: 'Unsupported billing model: {0}',
          loadModeInvalid: 'Unsupported load mode: {0}',
          billingMethodInvalid: 'Unsupported billing method: {0}',
          billingMethodNotSupported: 'Billing method does not match load mode: {0}',
          ftlOnlyUnitPrice: 'FTL mode only supports unit-price billing: {0}',
          dateRangeInvalid: 'Effective date cannot be later than expiry date',
          weightRangeInvalid: 'Weight end must be greater than weight start: {0}',
          expressSupplierNotFound: 'No corresponding express carrier in system: {0}',
          supplierEnterprise: {
            accountRequired: 'Linked accounts are required to match a supplier',
            accountUnknown: 'No supplier mapping for carrier [{0}], account [{1}]; verification required',
            notFound: 'No enabled supplier [{0}] matched in Customer Center; verification required',
            ambiguous: 'Multiple suppliers match [{0}] in Customer Center',
            conflict: 'Linked accounts [{0}] map to different suppliers; import blocked'
          },
          expressServiceTypeNotSupported: 'The express carrier does not support service type: {0}',
          cargoTypeNotFound: 'No corresponding cargo type in system: {0}',
          warehouseNotFound: 'No enabled warehouse matched for the current tenant: {0}',
          templateSheetNotFound: 'Express rate import template sheet was not found',
          templateHeaderInvalid: 'The express rate template header does not match the required customer template',
          serviceTypeInvalid: 'Unrecognized service type: {0}',
          paymentTermInvalid: 'Unrecognized payment term: {0}',
          currencyNotFound: 'Currency not found in system: {0}',
          countryNotFound: 'Country base data was not found in address: {0}',
          surchargeFormatInvalid: 'Invalid surcharge format: {0}',
          surchargeFeeNotFound: 'Surcharge fee was not found in system: {0}',
          surchargeUnitNotFound: 'Surcharge billing unit was not found in system: {0}',
          surchargePriceInvalid: 'Surcharge price must be a valid non-negative number: {0}',
          surchargePercentageNotAllowed: 'Surcharge [{0}] does not support percentage billing',
          weightTierGroupIncomplete: 'The logical weight-tier rate contains invalid rows; the whole group was rejected',
          weightTierPriceModeInvalid: 'Enter either unit price (optional additional weight price) or minimum charge (total price), and leave unused price fields blank',
          weightTierSurchargeConflict: 'Surcharge values differ within the same logical weight-tier rate',
          weightTierOverlap: 'Weight tiers overlap or repeat within the same logical rate',
          logicalRateSaveFailed: 'Failed to save the logical rate; check the task errors and input data',
          excelFormat: 'Excel Format'
        },
        warnings: {
          unsupportedFields: 'Fields [{0}] are not imported in this release and have been ignored',
          warehouseUnsupportedField: 'This field is not imported currently and has been ignored',
          warehouseTaxMerged: 'Tax-inclusive and tax-exclusive surcharges were merged because the current rate model does not store tax attributes',
          countryNotMatched: 'No country base data matched for address [{0}]; the original address has been saved',
          accountNoNotConfigured: 'Account [{0}] is not configured for the express carrier and has been saved as entered',
          transportModeNotStored: 'Transport mode [{0}] was used for grouping only and was not stored',
          addressHierarchyNotMatched: 'Address hierarchy [{0}] was not matched and was preserved in the detail address'
        }
      }
    }
  }
}
